import { formatDate, formatMonth, formatPrice } from "~/helpers/format";
import type { CountryIso, DateISO, Price } from "~/types";

export default function useFormat() {
  const { currency } = useBranch();
  const { locale, tCountry, rtl } = useLocalization();
  const { t, te } = useI18n();

  return {
    formatDate(date: DateISO) {
      return formatDate(date, locale.value);
    },

    formatMonth(monthIndex: number) {
      return formatMonth(monthIndex, locale.value);
    },

    displayPrice(price: Price | number) {
      const priceToDisplay = typeof price == 'number' ? price : price[currency];
      return formatPrice(priceToDisplay, locale.value, currency);
    },

    shortenCountry(country: CountryIso) {
      const key = `countries_short.${country}`;
      return te(key) ? t(key) : tCountry(country);
    },

    getDirection(action: "next" | "back") {
      const next = action == 'next';
      return rtl.value ? (next ? 'left' : 'right') : (next ? 'right' : 'left');
    }
  };
}